/**
 * Shared calculation-guide keys for accounting summary totals.
 * Body copy lives in i18n (no/en/sv).
 */
export const SUMMARY_CALC_GUIDE_KEYS = {
  profit: {
    titleKey: "accounting.summary.calc_guide.profit.title",
    bodyKey: "accounting.summary.calc_guide.profit.body",
    ariaKey: "accounting.summary.calc_guide.profit.info_aria",
  },
  income: {
    titleKey: "accounting.summary.calc_guide.income.title",
    bodyKey: "accounting.summary.calc_guide.income.body",
    ariaKey: "accounting.summary.calc_guide.income.info_aria",
  },
  costs: {
    titleKey: "accounting.summary.calc_guide.costs.title",
    bodyKey: "accounting.summary.calc_guide.costs.body",
    ariaKey: "accounting.summary.calc_guide.costs.info_aria",
  },
  labor: {
    titleKey: "accounting.summary.calc_guide.labor.title",
    bodyKey: "accounting.summary.calc_guide.labor.body",
    ariaKey: "accounting.summary.calc_guide.labor.info_aria",
  },
  supplier_invoices: {
    titleKey: "accounting.summary.calc_guide.supplier_invoices.title",
    bodyKey: "accounting.summary.calc_guide.supplier_invoices.body",
    ariaKey: "accounting.summary.calc_guide.supplier_invoices.info_aria",
  },
  item_lists: {
    titleKey: "accounting.summary.calc_guide.item_lists.title",
    bodyKey: "accounting.summary.calc_guide.item_lists.body",
    ariaKey: "accounting.summary.calc_guide.item_lists.info_aria",
  },
  voucher_expenses: {
    titleKey: "accounting.summary.calc_guide.voucher_expenses.title",
    bodyKey: "accounting.summary.calc_guide.voucher_expenses.body",
    ariaKey: "accounting.summary.calc_guide.voucher_expenses.info_aria",
  },
  expected_report_income: {
    titleKey: "accounting.summary.calc_guide.expected_report_income.title",
    bodyKey: "accounting.summary.calc_guide.expected_report_income.body",
    ariaKey: "accounting.summary.calc_guide.expected_report_income.info_aria",
  },
};
